export default __webpack_public_path__ + "f4a90d21562a4ab99b5d1260a6f3b609.png";